import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { AppConfig } from "./app/AppConfig";
import { assetService } from "./core/services/assetService";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "hu",
    fallbackLng: "hu",
    debug: !AppConfig.production,
    backend: {
      loadPath: assetService.getLocalePath(),
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
